import {CustomerProductSummary} from '../../../../../api';

// One-shot = aucune date de période : dès qu'il y a une date de début, le produit est récurrent.
export function isOneShotProduct(product: CustomerProductSummary): boolean {
  return product.startDate == null && product.endDate == null;
}

// Recherche sur tout le texte visible : nom + description, y compris les extra-features.
export function productMatchesSearch(product: CustomerProductSummary, term: string): boolean {
  const normalized = term.trim().toLowerCase();
  if (!normalized) return true;
  return collectSearchableText(product).includes(normalized);
}

function collectSearchableText(product: CustomerProductSummary): string {
  const parts = [product.productName, product.description ?? ''];
  for (const feature of product.extraFeatures) {
    parts.push(collectSearchableText(feature));
  }
  return parts.join(' ').toLowerCase();
}
